<template>
  <div class="column-layout-text-container">
    <div v-for="(section, index) in sections" :key="index">
      <h1>{{ section.title }}</h1>
      <p v-for="(paragraph, index) in section.paragraphs" :key="index">
        {{ paragraph.text }}
      </p>
    </div>
  </div>
</template>
<script>
  export default {
    name: 'ColumnLayoutText',
    components: {},
    props: {
      sections: {
        required: true,
        default: [],
        type: Array,
      },
    },
  };
</script>
<style lang="scss" scoped>
  .column-layout-text-container {
    h1 {
      font-size: 20px;
      font-weight: 600;
      line-height: 24px;
      color: #282828;
      margin-bottom: 16px;
    }
    p {
      margin: 0;
      color: #282828;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      margin-bottom: 24px;
    }
  }
</style>
